import LocalizedStrings from "react-localization";

export const spendsStrings = new LocalizedStrings({
  en: {
    spends: "Spends",
    changeYear: "Change year",
    compute: "Compute",
    reloadData: "Reload Data",
    includeExtraData: "Include Extra Data",
    transfer: "Transfer",
    fileName: "File name",
    downloadFile: "Download file",
    processMessages: "Process Messages",
    actionConfirmation: "Do you want to repeat the action?",
  },
  fr: {
    spends: "Valorisation",
    changeYear: "Changer l'année",
    compute: "Calculer",
    reloadData: "Recharger les données",
    includeExtraData: "Inclure des données supplémentaires",
    transfer: "Transférer",
    fileName: "Nom de fichier",
    downloadFile: "Télécharger le fichier",
    processMessages: "Messages de traitement",
    actionConfirmation: "Voulez-vous répéter l'action?",
  },
});
